export default __webpack_public_path__ + "static/media/background-ecopro.60cbe27f.jpg";